import axios from 'axios';


const api = axios.create({
    baseURL: window._server,
    timeout: 5000
})

export default api
